import { SENSOR_STATES } from '@linearb/linjs-common';
import { filterFormatter, FILTER_TYPES } from 'common/constants/filters';
import { getPMData } from 'common/services/pm.service';
import { filterSupportedTypesFields } from 'components/FilterMenus/FilterMenus.service';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { pmIntegrationSelector } from 'state/selectors/sensors-authorizations';

export const usePMConfigPMData = ({ setIsLoadingFilters, setGotResponse }) => {
  const [issueTypes, setIssueTypes] = useState([]);
  const [labels, setLabels] = useState([]);
  const [customFields, setCustomFields] = useState([]);
  const [dateTimeCustomFields, setDateTimeCustomFields] = useState([]);
  const [statuses, setStatuses] = useState([]);

  const pmSensor = useSelector(pmIntegrationSelector);
  const isAuthorized = pmSensor?.state === SENSOR_STATES.ok;

  useEffect(() => {
    const fetchData = async () => {
      setIsLoadingFilters(true);
      const data = await getPMData(isAuthorized, pmSensor?.sensor_id);
      setStatuses(data.statuses);
      setIssueTypes(data.issueTypes);
      setLabels(data.labels);
      setCustomFields(data.customFields); // only string-type fields: filterStringTypesFields(data.customFields)
      setDateTimeCustomFields(
        filterSupportedTypesFields(
          data.customFields,
          ['datetime', 'dateTime'],
          false,
          pmSensor?.sensor_id
        )
      );
      setGotResponse(true);
    };
    fetchData();
  }, []);

  const formattedIssueTypes =
    filterFormatter[FILTER_TYPES.ISSUE_TYPES](issueTypes);
  const formattedLabels = filterFormatter[FILTER_TYPES.LABEL](labels);
  const formattedFields = filterFormatter[FILTER_TYPES.FIELD](customFields);
  const formattedDateTimeFields =
    filterFormatter[FILTER_TYPES.FIELD](dateTimeCustomFields);

  return {
    issueTypes,
    statuses,
    customFields,
    formattedFields,
    formattedLabels,
    formattedDateTimeFields,
    formattedIssueTypes
  };
};
